import { render } from "./CoconutIcon.vue?vue&type=template&id=7b6166e4&scoped=true"
import script from "./CoconutIcon.vue?vue&type=script&lang=js"
export * from "./CoconutIcon.vue?vue&type=script&lang=js"

import "./CoconutIcon.vue?vue&type=style&index=0&id=7b6166e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6166e4"]])

export default __exports__